import { render, staticRenderFns } from "./chargeMoney.vue?vue&type=template&id=2251a217&scoped=true"
import script from "./chargeMoney.vue?vue&type=script&lang=js"
export * from "./chargeMoney.vue?vue&type=script&lang=js"
import style0 from "./chargeMoney.vue?vue&type=style&index=0&id=2251a217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251a217",
  null
  
)

export default component.exports